// AddressInfoSection.js
import React, { useEffect, useState } from "react";
import InputComponent from "../InputComponent";
import { FiMinus, FiPlus } from "react-icons/fi";
import { getValueFromPatToken } from "../../../patient/utils/commonUtils";
import { getClinicIdFromToken, getValueFromToken } from "../../utils/tokenUtils";
import { showToast } from "../../../patient/utils/toastUtils";
import { serviceFetchUserAddressDetails, serviceUpdateUserAddress } from "../../services/profileApi";

const AddressInfoSection = ({
  collapsed,
  toggleSection,
  callType
}) => {

  const [street1, setStreet1] = useState("");
  const [street2, setStreet2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [clinicId, setClinicId] = useState(null);
  const [userAddress, setUserAddress] = useState({
    street1: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });
  const [loginUserId, setLoginUserId] = useState(null);

  const fetchUserAddressDetails = async () => {
    let params = {
      user_id: loginUserId,
      clinic_id: clinicId,
      callType:callType
    }
    const response = await serviceFetchUserAddressDetails(params);
    
    if (response?.status) {
      const { address } = response?.data ;
    
      setUserAddress({
      street1: address?.street_1,
      street2: address?.street_2,
      city: address?.city,
      state: address?.state,
      country: address?.country,
      pincode: address?.pin_code,
      });
  
      setStreet1(address?.street_1);
      setStreet2(address?.street_2);
      setCity(address?.city);
      setState(address?.state);
      setCountry(address?.country);
      setPinCode(address?.pin_code);
    }    
  };

   // update addressInfo
   const updateAddressInfo = async () => {
    const response = await serviceUpdateUserAddress({
      userId: loginUserId,
      clinicId: clinicId,
      street1: street1 === "" ? null : street1,
      street2: street2 === "" ? null : street2,
      city: city === "" ? null : city,
      state: state === "" ? null : state,
      country: country === "" ? null : country,
      pinCode: pinCode === "" ? null : pinCode,
      callType:callType
    });

    if(response?.status){
      showToast(response?.message, "success");
    }else{
      showToast(response?.message, "error");
    }
  };

  useEffect(() => {
    let temp;
    if(callType === 'patient'){
      temp = getValueFromPatToken("user_id");
      console.log(temp,'useEffect')
    }else{        
      temp = getValueFromToken("user_id");
      setClinicId(getClinicIdFromToken())
    }
    setLoginUserId(temp)
  }, []);

  useEffect(() => { 
    if(loginUserId) 
    { 
      fetchUserAddressDetails (loginUserId);
    }
  }, [loginUserId]);
  return (
    <div className="section">
      <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
        <div className="text-left">Address Information</div>
        <button onClick={() => toggleSection("addressInfo")}>
          {collapsed ? <FiPlus /> : <FiMinus />}
        </button>
      </div>
      {!collapsed && (
        <div className="section-content px-5 py-12 border-b border-gray-200">
          <div className="flex flex-row flex-wrap -mx-3 gap-y-6">
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="Street 1"
                id="street1"
                value={street1}
                type="text"
                onChange={(e) => setStreet1(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="Street 2"
                id="street2"
                value={street2}
                type="text"
                onChange={(e) => setStreet2(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="Pincode"
                id="pincode"
                value={pinCode}
                type="text"
                onChange={(e) => setPinCode(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="City"
                id="city"
                value={city}
                type="text"
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="State"
                id="state"
                value={state}
                type="text"
                onChange={(e) => setState(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-4/12 px-3">
              <InputComponent
                label="Country"
                id="country"
                value={country}
                type="text"
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>
          </div>
          <button
            className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5 bg-[#2E37A4] text-white mt-6"
            onClick={updateAddressInfo}
          >
            Update
          </button>
        </div>
      )}
    </div>
  );
};

export default AddressInfoSection;
